// This file can be replaced during build by using the `fileReplacements` array.
// `ng build` replaces `environment.ts` with `environment.prod.ts`.
// The list of file replacements can be found in `angular.json`.

export const environment = {
  production: false,
   
  firebaseConfig: {
    projectId: "urbn-go",
    appId: "1:817141827679:web:ce5e0c12348b8b8d9873ea",
    storageBucket: "urbn-go.firebasestorage.app",
    apiKey: "AIzaSyBIOnOfJV7RgF_K2BLn0Kuy4AO5nJUDxcU",
    authDomain: "urbn-go.firebaseapp.com",
    messagingSenderId: "817141827679",
    measurementId: "G-HYW5BTKBCY"
  },

  googleMapsApiKey: "AIzaSyArFTtdLtdRyF838C6Ey4H4rE4hzZ32tEQ",  
};

/*
 * For easier debugging in development mode, you can import the following file
 * to ignore zone related error stack frames such as `zone.run`, `zoneDelegate.invokeTask`.
 *
 * This import should be commented out in production mode because it will have a negative impact
 * on performance if an error is thrown.
 */
// import 'zone.js/plugins/zone-error';  // Included with Angular CLI.
